import type { FaireProductEntity } from "../../entity_types/product";

export const p_rp8vpqsk9q: FaireProductEntity = {
  token: "p_rp8vpqsk9q",
  type: "product",
  name: "Cotton Multi Patch Wide Leg Palazzo Kantha Pan R26001",
  brandToken: "b_1ebsymwkg7",
  brandName: "Rising International Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/f4f293ffd62ec1d27d1a9086bf2b36e6ecb369bee76f96d1db625f5a41acbb8d.jpeg",
  galleryImageUrls: [],
  priceDollars: 88,
  description:
    "Indulge in the comfort and style of Rising International Inc's Cotton Multi Patch Wide Leg Palazzo Kantha Pant . These pants reflect a blend of Nepalese craftsmanship and modern fashion. Handmade by skilled artisans, the patchwork design creates a unique and stylish aesthetic. The elastic waistband ensures a comfortable fit, while the cotton material provides breathability and softness. These pants are more than just a clothing item, they are a testament to Nepalese culture and heritage. Wear them and carry a piece of Nepal with you.",
  tags: [],
  msrpDollars: 176,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:39.307Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
